import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

@Component({
    selector: 'app-editcontrolledareagate',
    templateUrl: './editcontrolledareagate.component.html',
    styleUrls: ['./editcontrolledareagate.component.scss'],
    standalone: false
})
export class EditcontrolledareagateComponent  extends SimpleModalComponent<any, null> {
  Form !: UntypedFormGroup;
  constructor() {
    super();
  }

  confirm() {
    this.close();
  }

}
